import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import styled from '@emotion/styled'
import { Dialog, color } from 'stylist'
import RouteVersion from 'routes/version'
import RoutePurchase from 'routes/purchase'
import RouteEstimate from 'routes/estimate'
import RouteAdmin from 'routes/admin'
import ErrorBoundary from 'components/ErrorBoundary'
import { redirectCancel } from 'utils'
import RouteAdminContainer from './routes/admin'

const PaddedTransparentDialog = styled(Dialog)`
  background: ${color('offWhite')};
  min-height: 100vh;
  box-shadow: none;
`

const DialogTitle = styled(Dialog.Title)`
  display: flex;
`

const SMPLogo = () => (
  <svg
    width="40px"
    height="30px"
    viewBox="0 -1 22 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="V3-Resp-Sources"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="01"
        transform="translate(-108.000000, -217.000000)"
        fillRule="nonzero"
      >
        <g id="Group" transform="translate(108.000000, 217.000000)">
          <path
            d="M12.7605105,16.5206349 C16.4270187,16.5206349 19.4129129,13.5013581 19.4129129,9.76031746 C19.4129129,6.01927685 16.4270187,3 12.7605105,3 C9.09400229,3 6.10810811,6.01927685 6.10810811,9.76031746 C6.10810811,13.5013581 9.09400229,16.5206349 12.7605105,16.5206349 Z M12.7605105,19.5206349 C7.42963586,19.5206349 3.10810811,15.1507919 3.10810811,9.76031746 C3.10810811,4.36984297 7.42963586,0 12.7605105,0 C18.0913852,0 22.4129129,4.36984297 22.4129129,9.76031746 C22.4129129,15.1507919 18.0913852,19.5206349 12.7605105,19.5206349 Z"
            id="Mask"
            fill="#627585"
          />
          <path
            d="M14.1591592,20.7206349 C15.5879516,20.7206349 16.7507508,19.5448355 16.7507508,18.0888889 C16.7507508,16.6329422 15.5879516,15.4571429 14.1591592,15.4571429 C12.7303667,15.4571429 11.5675676,16.6329422 11.5675676,18.0888889 C11.5675676,19.5448355 12.7303667,20.7206349 14.1591592,20.7206349 Z M14.1591592,21.7206349 C12.1755779,21.7206349 10.5675676,20.0946468 10.5675676,18.0888889 C10.5675676,16.0831309 12.1755779,14.4571429 14.1591592,14.4571429 C16.1427404,14.4571429 17.7507508,16.0831309 17.7507508,18.0888889 C17.7507508,20.0946468 16.1427404,21.7206349 14.1591592,21.7206349 Z"
            id="Oval-Copy"
            fill="#F5496C"
          />
          <path
            d="M13.4894895,14.0793651 C15.4141773,14.0793651 16.978979,12.4970687 16.978979,10.5396825 C16.978979,8.5822964 15.4141773,7 13.4894895,7 C11.5648017,7 10,8.5822964 10,10.5396825 C10,12.4970687 11.5648017,14.0793651 13.4894895,14.0793651 Z M13.4894895,15.0793651 C11.0100129,15.0793651 9,13.04688 9,10.5396825 C9,8.0324851 11.0100129,6 13.4894895,6 C15.9689661,6 17.978979,8.0324851 17.978979,10.5396825 C17.978979,13.04688 15.9689661,15.0793651 13.4894895,15.0793651 Z"
            id="Oval-Copy-2"
            fill="#805980"
          />
          <path
            d="M5.38738739,18.952381 C7.25318167,18.952381 8.77477477,17.4137762 8.77477477,15.5047619 C8.77477477,13.5957476 7.25318167,12.0571429 5.38738739,12.0571429 C3.52159311,12.0571429 2,13.5957476 2,15.5047619 C2,17.4137762 3.52159311,18.952381 5.38738739,18.952381 Z M5.38738739,20.952381 C2.41201549,20.952381 0,18.5133988 0,15.5047619 C0,12.496125 2.41201549,10.0571429 5.38738739,10.0571429 C8.36275928,10.0571429 10.7747748,12.496125 10.7747748,15.5047619 C10.7747748,18.5133988 8.36275928,20.952381 5.38738739,20.952381 Z"
            id="Oval-Copy-3"
            fill="#008594"
          />
          <path
            d="M14.1591592,20.7206349 C15.5879516,20.7206349 16.7507508,19.5448355 16.7507508,18.0888889 C16.7507508,16.6329422 15.5879516,15.4571429 14.1591592,15.4571429 C12.7303667,15.4571429 11.5675676,16.6329422 11.5675676,18.0888889 C11.5675676,19.5448355 12.7303667,20.7206349 14.1591592,20.7206349 Z"
            id="Path"
            fill="#FFFFFF"
          />
          <path
            d="M5.38738739,18.952381 C7.25318167,18.952381 8.77477477,17.4137762 8.77477477,15.5047619 C8.77477477,13.5957476 7.25318167,12.0571429 5.38738739,12.0571429 C3.52159311,12.0571429 2,13.5957476 2,15.5047619 C2,17.4137762 3.52159311,18.952381 5.38738739,18.952381 Z"
            id="Path"
            fill="#FFFFFF"
          />
        </g>
      </g>
    </g>
  </svg>
)

const App = ({ history, location, match }) => {
  if (window.Cypress) {
    // To allow tests to navigate easily
    window.routerHistory = history
  }
  return (
    <ErrorBoundary>
      <PaddedTransparentDialog size="fullscreen">
        {location.pathname !== "/admin" &&
          <div>
            <Dialog.Header onClose={redirectCancel}>
              <DialogTitle>
                <SMPLogo />
                Purchase Sample
              </DialogTitle>
            </Dialog.Header>
          </div>
        }
        <Dialog.Body>
          <Switch>
            <Route path="/version" component={RouteVersion} />
            <Route path="/purchase" component={RoutePurchase} />
            <Route path="/admin" component={RouteAdminContainer} />
            <Route path="/" component={RouteEstimate} />
          </Switch>
        </Dialog.Body>
      </PaddedTransparentDialog>
    </ErrorBoundary>
  )
}

export default withRouter(App)



// WEBPACK FOOTER //
// ./src/App.js